module.exports = __webpack_public_path__ + "img/12.baf10f1c.png";